/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-fragments */
import {
  CardElement,
  Elements,
  // LinkAuthenticationElement,
  PaymentElement,
  // linkAuthenticationElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Flex, Row, Col, Typography, message, Button, Collapse, Steps, Tooltip } from "antd";
import Reeact, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "src/components/layout";
import { SvgIcon } from "src/shared/icons";
import { AppDispatch } from "src/store";
import moment, { Moment } from "moment";
import { resetPayIntent, stripeSelector } from "src/store/stripe";
import { createPayIntent, createSubIntentToPayForCli, newActivatePaidClient, newActivateTrialClient } from "src/store/stripe/asyncRequests";
import { fullUserSelector, userSelector } from "src/store/user";
import { ConfirmButtons, Modal } from "../../../../ui";
import "./index.less";

import { Link } from "react-router-dom";
import { useBreakpoints } from "../../../../../helpers/useBreakpoints";
import { CollapseProps } from "antd/lib";
import { Timer } from "../PlansModal";

export function CheckoutForm({
  // checkout,
  // payIntentId,
  closeCheckoutShowPP,
  backStr = "Back to Plans",
  proceedStr = "Get Started",
  markIsSuccess,
  submit,

  // noteInBottom = `*You will only be charged for the subscription at the end of your free trial. To confirm your payment method, a temporary
  //       authorization of 50 cents will be processed, this amount will be immediately refunded to you.`,
}) {
  const stripe = useStripe();
  const elements = useElements();

  const { email, first_name, last_name } = useSelector(userSelector);
  const { loading_intent } = useSelector(stripeSelector);
  const [succMessage, setSuccMessage] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [paymentError, setPaymentError] = useState<any>(null);

  const [messageApi, contextHolder] = message.useMessage();
  const handleSubmit = async (event) => {
    setSuccMessage("");
    setPaymentError("");
    event?.preventDefault(); // might not need
    elements?.submit();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setIsLoading("Validating Card");

    const cardElement = elements.getElement(CardElement);
    const paymentElement = elements.getElement(PaymentElement);

    // Use your server to create a SetupIntent and get its client_secret

    const result = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
    });
    // console.log(result, "error, paymentMethod");

    if (result.error) {
      setIsLoading("");
      // console.error('Payment Error:', result?.error?.message);
      // setPaymentError(result?.error?.message || 'Error In Setting Up Card');
      messageApi.error(result?.error?.message || "Error In Setting Up Card", 6.5);
      // .then(() => {message.error(result?.error?.message || 'Error In Setting Up Card',5.5)
      //   message.success("Exporting finished", 5.5)
      // })
      // Handle payment errors
    } else {
      if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
        // console.log("Payment successful:", result);
        // messageApi
        // .success("Success", 5.5)

        setIsLoading("");
        // setSuccMessage('✅ Success');
        markIsSuccess(result?.paymentIntent?.payment_method);
        // Payment was successful, you can retrieve the amount from result.paymentIntent
      }
    }
  };

  useEffect(() => {
    if (submit) {
      handleSubmit();
    }
  }, [submit]);

  return (
    <form>
      {contextHolder}
      {/* <CardElement /> */}
      {/* <LinkAuthenticationElement /> */}
      <PaymentElement
        // Optional prop for prefilling customer information
        options={{
          defaultValues: {
            billingDetails: {
              name: `${first_name || ""} ${last_name || ""}`?.trim(),
              email, // check on Prod if the LINK is avaiable if not erase this
              // phone: '888-888-8888',
            },
          },
        }}
      />
      {/* <button type="submit">Pay Now</button> */}
      {paymentError ? (
        <div style={{ color: "red", fontWeight: 600, fontSize: "18px", marginTop: "10px" }}>Error: {paymentError}</div>
      ) : succMessage ? (
        <div style={{ color: "green", fontWeight: 600, fontSize: "18px", marginTop: "10px" }}>{succMessage}</div>
      ) : isLoading ? (
        <>
          <Flex vertical={true} align={"center"} gap={24} className={"loader-wrapper"} style={{ margin: "35px", marginBottom: "55px" }}>
            {" "}
            <Loader size="large" />{" "}
          </Flex>
        </>
      ) : (
        ""
      )}
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "space-between",
          justifyContent: "center",
          margin: "15px",
          marginLeft: "-5px",
        }}
      ></div>
    </form>
  );
}
interface PaymentMethodModalProps {
  onClose: () => void;
  payment?: boolean;
  successfulPayment?: any;
  checkout?: string;
  isTrial?: boolean;
  isGenericBillingFailed?: boolean;
  failedPayment?: boolean;
  failedPaymentSkipTrial?: boolean;
  paymentIntentToUse?: boolean;
  updatePaymentMethod?: boolean;
  forceSubtitle?: string;
  forceTitle?: string;
  discountType?: null | "price" | "extrCreds";
}

export const PaymentMethodModal: FC<PaymentMethodModalProps> = ({
  checkout,
  onClose,
  payment,
  discountType,
  successfulPayment,
  isTrial,
  failedPayment,
  failedPaymentSkipTrial,
  isGenericBillingFailed,
  paymentIntentToUse,
  forceTitle,
  forceSubtitle,
  updatePaymentMethod,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const stepsItems = [
    {
      title: "Today",
      description: <Typography.Paragraph className={"steps-description"}>Start 14 Day Free Trial & Generate Traction</Typography.Paragraph>,
    },
    {
      title: "Day 12",
      description: (
        <Typography.Paragraph className={"steps-description"}>An email reminder will notify you that your trial is almost over</Typography.Paragraph>
      ),
    },
    {
      title: "Day 14",
      description: (
        <Typography.Paragraph className={"steps-description"}>
          After your trial ends, your subscription begins. <Typography.Text className={"steps-link"}>Cancel anytime.</Typography.Text>
        </Typography.Paragraph>
      ),
    },
  ];
  const dispatch = useDispatch<AppDispatch>();
  const [openDet, setOpenDet] = useState(false);
  const [lastCheckedId, setlastCheckedId] = useState<any>("");
  const [submit, setSubmit] = useState(false);

  const submitPayment = () => {
    setSubmit((prev) => !prev); // Toggles the state
  };
  useEffect(() => {
    if (submit) {
      setTimeout(() => {
        setSubmit(false);
      }, 300);
    }
  }, [submit]);
  // useEffect(() => {

  // }, [isTrial,payment]);
  useEffect(() => {
    if (isGenericBillingFailed) {
      return;
    }
    if (payment) {
      if (isTrial) {
        dispatch(createPayIntent({}));
      } else {
        dispatch(createSubIntentToPayForCli({ plan: checkout, priceDiscount: discountType === "price" }));
      }
    } else {
      // for 50 cent small charge to change card
      // setlastCheckedId(checkout)
      dispatch(createPayIntent({}));
    }
  }, []);

  const markIsSuccess = async (payMethodId) => {
    // console.log(payMethodId, 'payMethodIdpayMethodId');
    // if(!payment){
    if (isGenericBillingFailed) {
      return;
    }
    if (payment) {
      // for update card and trial to refund their 50 cent
      if (isTrial) {
        dispatch(newActivateTrialClient({ checkout, payIntentIdentification, payMethodId, discountType }));
        await new Promise((r) => setTimeout(r, 1300));
      } else {
      }
    } else {
    }
    successfulPayment();
  };
  // setFadeOut(true)
  // setTimeout(() => {
  //   setSuccessFullyMadeClient(true)
  //   // add call for backedn to create the accoutn and perhaps refresh page with use effect or show the end client as being premium or whatever
  // }, 200)

  const { isDesktop } = useBreakpoints();
  const handleCls = () => {
    if (!isGenericBillingFailed && onClose) {
      dispatch(resetPayIntent());
      onClose();
    }
    // if (onClose) {
    // }
  };
  const stripe = loadStripe(import.meta.env.VITE_REACT_APP_STRIPE_PK);
  let { payIntentId, payIntentIdentification } = useSelector(stripeSelector);
  const { planToDisplay } = useSelector(fullUserSelector);
  console.log(planToDisplay, "planToDisplay");
  payIntentId = paymentIntentToUse || payIntentId;
  console.log(paymentIntentToUse, payIntentId, "payIntentIdpaymentIntentToUse");
  // failedPayment;
  // failedPaymentSkipTrial;
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Powerful Dialer",
      children: (
        <>
          <div>
            <h3>Key features include:</h3>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> Call up to 20 prospects at a
              time
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> TCPA compliant dialer
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> Real time information on the
              prospect that picked up
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> AI recommended opener lines
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> Phone number included, with free
              swaps to increase pickups
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> Unlimited recording storage
            </div>
            <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
              {" "}
              <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} /> Spotify integration to enjoy
              music until someone answers
            </div>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: "Smart Email Sender",
      children: (
        <div>
          <h3>Key features include:</h3>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Unlimited email sends
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            AI personalized emails based on real time activity
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Auto-rotating email sender
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Connect up to 10 email accounts per account
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Unified email inbox for easy replying and tracking
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            A/B tested emails, auto-optimized based off of analytics
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Unlimited email warmups
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            GDPR, CCPA, and CPRA compliant
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: "AI Scheduler",
      children: (
        <div>
          <h3>Key features include:</h3>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            AI email scheduling agent included to follow up and book prospects
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Calendar scheduling links with customizable routing
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Connect several calendars to check availability across them
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            One-click unique link that instantly books the meeting. No email input, no extra steps.
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Zoom, Teams, and Google Meets native integrations
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Side by side availability view for simple scheduling
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Customize questions, reminders, and unique time blockers for your scheduling link
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: "CRM",
      children: (
        <div>
          <h3>Key features include:</h3>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Manage deals and their stage with a drag and drop table
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Filter, view, and edit contacts inside the system
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Intuitive graphs and charts to show outreach analytics
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Click on any prospect to see their outreach history and interact with them directly
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Download and export analytics to Excel
          </div>
        </div>
      ),
    },
    {
      key: "5",
      label: "Teams",
      children: (
        <div>
          <h3>Key features include:</h3>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Team analytics and overview
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Admin users to set up and manage team
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Round robin meeting links
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Integrations with all of your sales stack to keep everything up to date
          </div>
          <div style={{ margin: "6px", display: "flex", justifyItems: "center", alignItems: "center" }}>
            <SvgIcon type={"checked2"} width={23} height={23} className={"advantage-icon"} style={{ marginRight: "10px" }} />
            Onboarding help during the setup is included
          </div>
        </div>
      ),
    },
  ];
  const [midAfter, setMidAfter] = useState();
  const [isPriceDis, setIsPriceDis] = useState(false);
  const [promoter, setPromoter] = useState();
  const now = moment();
  return isDesktop ? (
    <>
      <Modal rootClassName={"payment-method-modal"} title={"Meetz details"} open={openDet} onCancel={() => setOpenDet(false)} zIndex={10000}>
        <Collapse items={items} />
      </Modal>
      <Modal
        rootClassName={"payment-method-modal"}
        title={
          forceTitle ? (
            forceTitle
          ) : payment ? (
            failedPayment ? (
              `Your payment has failed`
            ) : (
              <div style={{ fontSize: "18px", fontWeight: 600 }}>
                {isTrial ? "Trial Summary - " : "Plan Summary - "}
                {/* {checkout === "scheduler"
                ? "Ai Email Scheduling "
                : checkout === "starter"
                ? "Starter Plan "
                : checkout === "growth"
                ? "Growth Plan "
                : "Ultimate Plan "} */}
                Team Plan
              </div>
            )
          ) : updatePaymentMethod ? (
            "Update billing method - Meetz"
          ) : (
            "Update Invoice - Meetz"
          )
        }
        open={true}
        onCancel={handleCls}
        closeIcon={!failedPayment}
      >
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          {/* <Flex
            justify={now?.isAfter(midAfter) ? "center" : "space-between"}
            align={"center"}
            className={"discount-wrapper"}
            style={{ display:   "none" }}
          >
            <Typography.Paragraph className={"discount-text"}>
              {isPriceDis
                ? `Exclusive ${promoter} Package • 20% Discount On Your Meetz Plan, For The First 12 Months!`
                : `New User Discount 🚀 20% Extra Credits On Your Meetz Plan, For The First 12 Months!`}
            </Typography.Paragraph>
            <div className={"package-countdown"} style={{ display: "none" }}>
              <Timer
                midAfter={midAfter}
                setMidAfter={setMidAfter}
                isPriceDis={isPriceDis}
                setIsPriceDis={setIsPriceDis}
                promoter={promoter}
                setPromoter={setPromoter}
              />
            </div>
          </Flex> */}
          {forceSubtitle ? (
            <div style={{ marginBottom: "30px" }}> {forceSubtitle}</div>
          ) : (
            !isTrial && (
              <div style={{ marginBottom: "30px" }}>
                {failedPayment ? (
                  <>
                    Fix your payment below to unlock Meetz {!failedPaymentSkipTrial ? `and start getting leads!` : `to resume your outreach!`}
                    <br />{" "}
                    {checkout === "scheduler"
                      ? "Ai Email Scheduling "
                      : checkout === "starter"
                      ? "Starter Plan "
                      : checkout === "growth"
                      ? "Growth Plan "
                      : "Ultimate Plan "}
                  </>
                ) : (
                  `Activate Meetz - `
                )}
                <span
                  style={{
                    color: "#757a89",
                    textDecoration: "line-through",
                  }}
                >
                  {discountType === "price" ? (
                    <> {checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
                  ) : (
                    ""
                  )}
                </span>{" "}
                {discountType === "price" ? (
                  <span style={{ color: "#0fca7a" }}>
                    {checkout === "scheduler" ? "$39" : checkout === "starter" ? "$39" : checkout === "growth" ? "$79" : "$159"}
                  </span>
                ) : (
                  <>{checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
                )}
                <br />
                {discountType === "extrCreds" ? <span style={{ color: "#0fca7a" }}>20% More Credits for the first 12 months</span> : ""}
              </div>
            )
          )}
          <div>
            {!!isTrial && (
              <div style={{ marginBottom: "5px" }}>
                {" "}
                {/* <Row className={"steps-wrapper"}>
                  <Steps
                    current={1}
                    size={"small"}
                    direction={isDesktop ? "horizontal" : "vertical"}
                    labelPlacement={"vertical"}
                    items={stepsItems}
                    progressDot={() => <Row className={"steps-dot"}></Row>}
                  />
                </Row>{" "} */}
                {/* <span
                style={{
                  color: "#757a89",
                  textDecoration: "line-through",
                }}
              >
                {" "}
                {discountType !== "price" ? (
                  <> {checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
                ) : (
                  ""
                )}{" "}
              </span>
              <span
                style={{
                  color: "#757a89",
                  textDecoration: "line-through",
                }}
              >
                {discountType !== "price" ? (
                  <> {checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
                ) : (
                  ""
                )}
              </span>{" "}
              <br />
              <br />
              {discountType === "extrCreds" ? <span style={{ color: "#0fca7a" }}>20% More Credits for the first 12 months</span> : ""} */}
                <div style={{ color: "black", marginBottom: "10px" }}>Plan details:</div>
                Price per month (After trial):{" "}
                {planToDisplay?.discount > 0 ? (
                  <>
                    <span
                      style={{
                        color: "#757a89",
                        textDecoration: "line-through",
                      }}
                    >
                      {planToDisplay?.price}
                    </span>{" "}
                    <span>{Math.floor(planToDisplay?.price - (planToDisplay?.price * planToDisplay?.discount) / 100)}</span>
                    <span style={{ color: "#0fca7a" }}> {planToDisplay?.discount}% off</span>
                  </>
                ) : (
                  <>
                    <span>{Math.floor(planToDisplay?.price)}</span>
                  </>
                )}
                <br /> Team Seats: {planToDisplay?.seats_allowed}
                <br />
                Prospects can upload:{" "}
                {discountType === "extrCreds" ? (
                  <>
                    <span
                      style={{
                        color: "#757a89",
                        textDecoration: "line-through",
                      }}
                    >
                      {(+planToDisplay?.pros_allowed || 0)?.toLocaleString()}
                    </span>{" "}
                    <span>{Math.floor((+planToDisplay?.pros_allowed || 0) * 1.2)?.toLocaleString()}</span>{" "}
                    <span style={{ color: "#0fca7a" }}>
                      {" "}
                      20% extra{" "}
                      <Tooltip
                        placement={"right"}
                        title={
                          <>
                            New User Discount 🚀 20% Extra Credits On Your Meetz Plan, For The First 12 Months!
                            <div style={{ marginRight: "auto", width: "fit-content" }}>
                              {" "}
                              <Timer
                                midAfter={midAfter}
                                setMidAfter={setMidAfter}
                                isPriceDis={isPriceDis}
                                setIsPriceDis={setIsPriceDis}
                                promoter={promoter}
                                setPromoter={setPromoter}
                              />
                            </div>
                          </>
                        }
                      >
                        <SvgIcon type={"tooltip"} style={{ marginLeft: 5, cursor: "pointer" }} />
                      </Tooltip>
                    </span>
                  </>
                ) : (
                  (+planToDisplay?.pros_allowed || 0)?.toLocaleString()
                )}
                <br /> All Meetz functionality included {planToDisplay?.seats_allowed === 1 ? "(Except team functionality) " : ""}-{" "}
                <Button className="link" onClick={() => setOpenDet(true)}>
                  See details
                </Button>
                <br />
                {/* No email sending limitations */}
                <br />
                <br />
                This is to verify your account,<span style={{ fontWeight: 500 }}> you will not be charged during the 14 day free trial.</span>
              </div>
            )}
            {payIntentId ? (
              // <>
              <Elements stripe={stripe} options={{ clientSecret: payIntentId, loader: "auto", paymentMethodCreation: "manual" }}>
                <CheckoutForm
                  // payIntentId={payIntentId}
                  markIsSuccess={markIsSuccess}
                  closeCheckoutShowPP={handleCls}
                  submit={submit}
                  // checkout={checkout}
                />
              </Elements>
            ) : (
              // </>
              <Flex vertical={true} align={"center"} gap={24} className={"loader-wrapper"} style={{ margin: "35px", marginBottom: "55px" }}>
                {" "}
                <Loader size="large" />{" "}
              </Flex>
            )}
          </div>
          <div>
            <ConfirmButtons
              leftButtonTitle={!failedPayment && "Back"}
              // leftButtonTitle={!failedPayment && "Back to Plans"}
              rightButtonTitle={isTrial ? "Get Started" : updatePaymentMethod ? `Update payment method` : "Activate Meetz"}
              handleSubmit={submitPayment}
              onCancel={handleCls}
            />
          </div>
          <span style={{ fontSize: "12px", color: "grey", marginTop: "35px" }}>
            {isTrial
              ? `*You will only be charged for the subscription at the end of your free trial. To confirm your payment method, a temporary authorization of 50 cents will be processed, this amount will be immediately refunded to you`
              : updatePaymentMethod
              ? `*To confirm your payment method, a temporary authorization of 50 cents will be processed, this amount will be immediately refunded to you`
              : `Cancel anytime, no commitment necessary `}
            {discountType ? "- Checkout now to lock in your discount" : ""}
          </span>
        </div>
      </Modal>
    </>
  ) : (
    <Flex className={"payment-method-page-wrapper"} vertical={true}>
      <Row className={"mobile-gradient1"} />
      <Row className={"mobile-gradient2"} />
      <Col className={"box"} style={{ padding: "32px 18px" }}>
        {" "}
        {failedPayment ? (
          <div style={{ fontSize: "18px", fontWeight: 600 }}>Your payment has failed</div>
        ) : (
          <div style={{ fontSize: "18px", fontWeight: 600 }}>
            {isTrial ? "Trial Summary - " : "Plan Summary - "}
            {checkout === "scheduler"
              ? "Ai Email Scheduling "
              : checkout === "starter"
              ? "Starter Plan "
              : checkout === "growth"
              ? "Growth Plan "
              : "Ultimate Plan "}
          </div>
        )}
        <br />
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "fit-content" }}>
          {!isTrial && (
            <div style={{ marginBottom: "30px" }}>
              {failedPayment ? (
                <>
                  Fix your payment below to unlock Meetz {!failedPaymentSkipTrial ? `and start getting leads!` : `to resume your outreach!`}
                  <br />{" "}
                  {checkout === "scheduler"
                    ? "Ai Email Scheduling "
                    : checkout === "starter"
                    ? "Starter Plan "
                    : checkout === "growth"
                    ? "Growth Plan "
                    : "Ultimate Plan "}
                </>
              ) : (
                `Activate Meetz - `
              )}
              <span
                style={{
                  color: "#757a89",
                  textDecoration: "line-through",
                }}
              >
                {discountType === "price" ? (
                  <> {checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
                ) : (
                  ""
                )}
              </span>{" "}
              {discountType === "price" ? (
                <span style={{ color: "#0fca7a" }}>
                  {checkout === "scheduler" ? "$39" : checkout === "starter" ? "$39" : checkout === "growth" ? "$79" : "$159"}
                </span>
              ) : (
                <>{checkout === "scheduler" ? "$49" : checkout === "starter" ? "$49" : checkout === "growth" ? "$99" : "$199"}</>
              )}
              <br />
              {discountType === "extrCreds" ? <span style={{ color: "#0fca7a" }}>20% More Credits for the first 12 months</span> : ""}
            </div>
          )}
          <div>
            {!!isTrial && (
              <div style={{ marginBottom: "15px" }}>
                {" "}
                This is to verify your account,<span style={{ fontWeight: 500 }}> you will not be charged during the 14 day free trial.</span>
              </div>
            )}
            {payIntentId ? (
              // <>
              <Elements stripe={stripe} options={{ clientSecret: payIntentId, loader: "auto", paymentMethodCreation: "manual" }}>
                <CheckoutForm
                  // payIntentId={payIntentId}
                  markIsSuccess={markIsSuccess}
                  closeCheckoutShowPP={handleCls}
                  submit={submit}
                  // checkout={checkout}
                />
              </Elements>
            ) : (
              // </>
              <Flex vertical={true} align={"center"} gap={24} className={"loader-wrapper"} style={{ margin: "35px", marginBottom: "55px" }}>
                {" "}
                <Loader size="large" />{" "}
              </Flex>
            )}
          </div>
          <div>
            <ConfirmButtons
              leftButtonTitle={!failedPayment && "Back to Plans"}
              rightButtonTitle={isTrial ? "Get Started" : "Activate Meetz"}
              handleSubmit={submitPayment}
              onCancel={!failedPayment && handleCls}
            />
          </div>
          <span style={{ fontSize: "12px", color: "grey", marginTop: "35px" }}>
            {isTrial
              ? `*You will only be charged for the subscription at the end of your free trial. To confirm your payment method, a temporary authorization of 50 cents will be processed, this amount will be immediately refunded to you`
              : `Cancel anytime, no commitment necessary `}
            {discountType ? "- Checkout now to lock in your discount" : ""}
          </span>
        </div>
      </Col>
      {/* <Link to={"/"} className={"meetz-link"}>
        Meetz.ai
      </Link> */}
    </Flex>
  );
};
